import React from 'react';
import classes from './TurnGuide.module.scss';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { TurnType } from '@envclient/envengine/src/envs/koenigsburg/KEnv';

interface Props {
  turnType: TurnType;
}

const TurnGuide = ({ turnType }: Props) => {
  const [minimized, setMinimized] = React.useState<boolean>(true);

  const renderMinimized = () => {
    return (
      <>
        {turnType === ('tile' as const) && <p>1. Place the 3 tiles.</p>}
        {turnType === 'resource' && <p>2. Collect resources</p>}
        {turnType === 'taxman' && <p>3. Place a toll collector (optional)</p>}
      </>
    );
  };

  const renderExpanded = () => {
    return (
      <>
        {turnType === 'tile' && (
          <p>
            1. Place the 3 tiles on the left to build resources.
            <br />
            Click a red circle to place a worker on the resource (optional).
            <br />
            You can also turn and place one of your castles -<br /> click hexa tile at bottom-left.
          </p>
        )}
        {turnType === 'resource' && (
          <p>
            2. Click Submit to apply the automatically harvested resources - outlined in red.
            <br /> If more than one city gate is possible - you can modify the selection by clicking on the outlined
            resources.
          </p>
        )}
        {turnType === 'taxman' && <p>3. You can place a toll collector to the highlighted city gate (optional).</p>}
      </>
    );
  };

  return (
    <div className={classes.main} onClick={() => setMinimized(!minimized)}>
      {minimized ? renderMinimized() : renderExpanded()}
      <div className={classes.toggle}>{minimized ? <FaChevronUp /> : <FaChevronDown />}</div>
    </div>
  );
};

export default TurnGuide;
